import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAks = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 30 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9971 1.13818L2.38715 7.1483C1.77977 7.49282 1.27547 7.98799 0.924864 8.58409C0.574257 9.1802 0.389676 9.85627 0.389648 10.5445V22.5598C0.390368 23.2478 0.575534 23.9235 0.926571 24.5192C1.27761 25.1149 1.78217 25.6095 2.38965 25.9535L12.9971 31.9661C13.6052 32.3104 14.295 32.4917 14.9971 32.4917C15.6993 32.4917 16.3891 32.3104 16.9971 31.9661L27.6096 25.956C28.2171 25.612 28.7217 25.1173 29.0727 24.5216C29.4238 23.926 29.6089 23.2503 29.6096 22.5622V10.5445C29.6089 9.85645 29.4238 9.18072 29.0727 8.58506C28.7217 7.9894 28.2171 7.49475 27.6096 7.15075L16.9971 1.13818C16.3891 0.793833 15.6993 0.612549 14.9971 0.612549C14.295 0.612549 13.6052 0.793833 12.9971 1.13818Z",
			fill: "#7E4799"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2029 13.1286L11.2654 14.2488V9.61133L14.2029 10.6388V13.1286Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.59424 10.3891V13.4018L10.8167 14.2492V9.61255L8.59424 10.3891ZM9.09424 13.3084L8.74824 13.1892V10.6513L9.09424 10.5394V13.3084ZM9.75949 13.5045L9.27199 13.3447V10.4933L9.75949 10.3438V13.5045ZM10.5907 13.7532L9.94549 13.5555V10.3067L10.5907 10.1214V13.7532Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0371 17.7666L8.09937 18.8864V14.2493L11.0371 15.2767V17.7666Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.42749 15.0266V18.0392L7.64974 18.8864V14.2493L5.42749 15.0266ZM5.92749 17.9446L5.58249 17.8271V15.2885L5.92849 15.1769L5.92749 17.9446ZM6.59249 18.1408L6.10524 17.9811V15.1298L6.59249 14.9802V18.1408ZM7.42474 18.3911L6.77974 18.195V14.9439L7.42499 14.7588L7.42474 18.3911Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.5725 17.7666L21.6348 18.8864V14.2493L24.5725 15.2767V17.7666Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9626 15.0266V18.0392L21.1854 18.8864V14.2493L18.9626 15.0266ZM19.4626 17.9446L19.1176 17.8271V15.2885L19.4636 15.1769L19.4626 17.9446ZM20.1276 18.1408L19.6404 17.9811V15.1298L20.1276 14.9802V18.1408ZM20.9601 18.3911L20.3149 18.195V14.9439L20.9601 14.7588V18.3911Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0505 13.1362L18.1128 14.2561V9.61865L21.0505 10.6463V13.1362Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4407 10.3967V13.4089L17.6634 14.2561V9.61865L15.4407 10.3967ZM15.9407 13.3147L15.5947 13.1958V10.6581L15.9407 10.5465V13.3147ZM16.6057 13.5109L16.1184 13.3512V10.5002L16.6057 10.3506V13.5109ZM17.4372 13.7598L16.7919 13.5619V10.3136L17.4372 10.1284V13.7598Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2029 22.3645L11.2654 23.4846V18.8472L14.2029 19.8746V22.3645Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.59424 19.6245V22.6371L10.8167 23.4846V18.8472L8.59424 19.6245ZM9.09424 22.5437L8.74824 22.4245V19.8866L9.09424 19.7748V22.5437ZM9.75949 22.7399L9.27199 22.58V19.7287L9.75949 19.5791V22.7399ZM10.5907 22.9885L9.94549 22.7909V19.5421L10.5907 19.3567V22.9885Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0505 22.3718L18.1128 23.4917V18.8542L21.0505 19.8819V22.3718Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4407 19.6318V22.6445L17.6634 23.4909V18.8542L15.4407 19.6318ZM15.9407 22.5498L15.5947 22.4309V19.8937L15.9407 19.7821V22.5498ZM16.6057 22.7472L16.1184 22.5876V19.7358L16.6057 19.5862V22.7472ZM17.4372 22.9961L16.7919 22.7982V19.5492L17.4372 19.364V22.9961Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8626 17.7597L14.9248 18.8799V14.2424L17.8626 15.2699V17.7597Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.2534 15.0197V18.0324L14.4752 18.8799V14.2424L12.2534 15.0197ZM12.7534 17.9378L12.4074 17.8186V15.2819L12.7534 15.1701V17.9378ZM13.4184 18.1352L12.9312 17.9753V15.124L13.4184 14.9744V18.1352ZM14.2502 18.385L13.6049 18.1874V14.9374L14.2502 14.752V18.385Z",
			fill: "white"
		})
	] })
});
export default SvgAks;
